import * as React from 'react';
import { useDispatch } from 'react-redux';
import { TDispatch } from '../../../../../common/types/dispatch';
import { PublishTermsError } from './PublishTermsError';
import { loadPublishTerms } from '../../../../thunks/publishTerms/loadPublishTerms';
import { useTelemetry } from '../../../../../common/hooks';

export const PublishTermsErrorContainer = () => {
  const dispatch = useDispatch<TDispatch>();

  const { increment } = useTelemetry();

  const handleRetryClick = React.useCallback(() => {
    dispatch(loadPublishTerms());
  }, [dispatch]);

  React.useEffect(() => {
    increment('servicesLoadError');
  }, [dispatch, increment]);

  return <PublishTermsError handleRetryClick={handleRetryClick} />;
};
